"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _default2 = require("@/views/product/creatProduct/default");
var _productEnums = require("@/enums/productEnums");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var headTabList = [{
  tit: '商品信息',
  name: '1'
}, {
  tit: '规格库存',
  name: '2'
}, {
  tit: '预约设置',
  name: '5'
}, {
  tit: '商品详情',
  name: '3'
}, {
  tit: '其他设置',
  name: '4'
}];
var _default = exports.default = {
  data: function data() {
    return {
      headTab: [],
      formValidate: Object.assign({}, _default2.defaultObj),
      attrInfo: {},
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      timeCheckGroup: [],
      //自动划分当前选中的元素
      isCustomize: false
    };
  },
  mounted: function mounted() {
    if (this.formValidate.type === 7) {
      this.headTab = headTabList;
    } else {
      this.headTab = headTabList.slice(0, 2).concat(headTabList.slice(3));
    }
  },
  methods: {
    // 获取详情中的规格数据，预约 采集的时候 只有一条规格，这里做处理
    getAttrList: function getAttrList(info, type) {
      if (this.formValidate.type === this.OrderSecondTypeEnum.Reservation) {
        return type === 'copy' && info.attrList.length > 1 ? info.attrList.slice(0, 1) : info.attrList;
      } else {
        return info.attrList;
      }
    },
    // 获取编辑时候的规格数据
    getAttrs: function getAttrs(info) {
      var _this2 = this;
      if (info.specType) {
        if (info.attrValueList) {
          info.attrValueList.forEach(function (val) {
            val.image = _this2.$selfUtil.setDomain(val.image);
            val.attrValueShow = JSON.parse(val.attrValue);
            val.attr_arr = val.sku.split(',');
            val.brokerage = val.brokerage || 0;
            val.brokerageTwo = val.brokerageTwo || 0;
            val.vipPrice = val.vipPrice || 0;
          });
          this.ManyAttrValue = [].concat(_toConsumableArray(this.oneFormBatch), _toConsumableArray(info.attrValueList));
        } else {
          if (this.formValidate.attrList.length) {
            this.oneFormBatch[0].image = this.$selfUtil.setDomain(info.image);
          }
        }
        this.formValidate.attrs = this.formValidate.attrList.map(function (i) {
          return {
            value: i.attributeName,
            detail: i.optionList.map(function (val) {
              return {
                value: val.optionName,
                image: val.image
              };
            }),
            add_pic: i.isShowImage ? 1 : 0
          };
        });
      } else {
        this.OneattrValue = info.attrValueList;
      }
    },
    getData: function getData(res, type, editOrCopy) {
      var _this3 = this;
      var info = res;
      this.formValidate.content = '';
      var deliveryMethods = this.formValidate.type === this.OrderSecondTypeEnum.Reservation ? ['3'] : ['1'];
      this.formValidate = _objectSpread(_objectSpread({}, info), {}, {
        image: this.$selfUtil.setDomain(info.image),
        sliderImages: JSON.parse(info.sliderImage),
        cateIds: info.cateId ? info.cateId.split(',') : [],
        // 商品分类id
        sort: info.sort ? info.sort : 0,
        stock: info.stock ? info.stock : 0,
        attrList: info.attrList ? this.getAttrList(info, type) : [],
        attrValueList: info.attrValueList ? info.attrValueList : [],
        isSub: info.isSub ? info.isSub : false,
        content: info.content ? this.$selfUtil.replaceImgSrcHttps(info.content) : '',
        id: info.id ? info.id : 0,
        coupons: info.coupons ? info.coupons : [],
        couponIds: info.couponIds ? info.couponIds : [],
        type: info.type ? info.type : Number(this.$route.params.productType),
        guaranteeIdsList: info.guaranteeIds ? info.guaranteeIds.split(',').map(Number) : [],
        //保障服务
        vipPriceType: info.vipPriceType ? info.vipPriceType : 0,
        deliveryMethodList: info.deliveryMethod ? info.deliveryMethod.split(',') : deliveryMethods,
        systemFormId: info.systemFormId ? info.systemFormId : null,
        refundSwitch: type === 'add' ? info.refundSwitch : true,
        supplementReservation: info.supplementReservation ? _objectSpread(_objectSpread({}, info.supplementReservation), {}, {
          reservationDateWeekRangeList: info.supplementReservation.reservationDateWeekRange ? info.supplementReservation.reservationDateWeekRange.split(',').map(Number) : [1, 2, 3, 4, 5, 6, 7]
        }) : {},
        temporaryData: {
          customizeTimeClone: [['', '']],
          // 自定义划分库存
          reservationTime: ['', ''] // 自动划分起止时间
        }
      });
      // 复制商品 卡密类型，置空卡密选择
      if (editOrCopy === 'copy') {
        info.attrValueList.forEach(function (val) {
          val.cdkeyLibraryName = '';
          val.cdkeyId = 0;
        });
      }
      this.getAttrs(info); // 规格数据

      this.htmlKey++;
      this.labelarr = info.keyword ? info.keyword.split(',') : [];
      if (this.formValidate.categoryId) {
        this.getbrandList();
        this.brandList.push({
          name: '其他',
          id: 0
        });
      }
      if (type !== 'copy' && info.type === this.OrderSecondTypeEnum.Reservation) this.getReservationInfo(info);
      if (type === 'copy') this.getImageList(); // 采集商品处理图片
      this.getProductCouponList(); // 优惠券

      var imgs = JSON.parse(info.sliderImage);
      var imgss = [];
      Object.keys(imgs).map(function (i) {
        imgss.push(_this3.$selfUtil.setDomain(imgs[i]));
      });
      this.formValidate.sliderImages = [].concat(imgss);
      if (this.getFileType(this.formValidate.sliderImages[0]) == 'video') {
        //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
        this.$set(this, 'videoLink', this.formValidate.sliderImages[0]);
        this.formValidate.sliderImages.splice(0, 1);
      }
      // 次卡商品规格处理
      if (this.formValidate.type == this.OrderSecondTypeEnum.PunchCard) {
        this.formValidate.specType = false;
        this.formValidate.attrs = [];
        this.formValidate.attrList = [];
        this.formValidate.attrValueList = [];
      }
    },
    //加载优惠券数据
    getProductCouponList: function getProductCouponList() {
      var _this4 = this;
      if (this.formValidate.couponIds && this.formValidate.couponIds.length) {
        (0, _product.productCouponListApi)().then(function (res) {
          var ids = _this4.formValidate.couponIds.toString();
          var arr = res;
          var obj = {};
          for (var i in arr) {
            obj[arr[i].id] = arr[i];
          }
          var strArr = ids.split(',');
          var newArr = [];
          var _iterator = _createForOfIteratorHelper(strArr),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (obj[item]) {
                newArr.push(obj[item]);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this4.$set(_this4.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
        });
      }
    },
    // 采集商品处理图片，获取所有图片集合
    getImageList: function getImageList() {
      // 合并并去重图片
      var allImages = [];
      // 添加封面图
      if (this.formValidate.image) {
        allImages.push(this.formValidate.image);
      }
      // 添加轮播图
      if (this.formValidate.sliderImages && this.formValidate.sliderImages.length > 0) {
        allImages.push.apply(allImages, _toConsumableArray(this.formValidate.sliderImages));
      }
      // 添加规格值图片
      if (this.formValidate.specType && this.formValidate.attrValueList) {
        this.formValidate.attrValueList.forEach(function (item) {
          if (item.image) {
            allImages.push(item.image);
          }
        });
      }

      // 去重图片数组
      var uniqueImages = _toConsumableArray(new Set(allImages));

      // 过滤出需要下载并重新上传的图片（外部链接图片）
      var externalImages = uniqueImages.filter(function (img) {
        return img && typeof img === 'string' && img.startsWith('http');
      });

      // 处理外部图片下载并重新上传
      if (externalImages.length > 0) {
        this.handleExternalImages(externalImages);
      }
    },
    handleExternalImages: function () {
      var _handleExternalImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(externalImages) {
        var _this5 = this;
        var uploadPromises, uploadResults, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              // 为每个外部图片创建上传Promise
              uploadPromises = externalImages.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(imgUrl) {
                  var newUrl, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        _context.p = 0;
                        _context.n = 1;
                        return _this5.getImgData(imgUrl);
                      case 1:
                        newUrl = _context.v;
                        return _context.a(2, {
                          oldUrl: imgUrl,
                          newUrl: newUrl
                        });
                      case 2:
                        _context.p = 2;
                        _t = _context.v;
                        console.error('图片上传失败:', imgUrl, _t);
                        return _context.a(2, {
                          oldUrl: imgUrl,
                          newUrl: imgUrl
                        });
                    }
                  }, _callee, null, [[0, 2]]);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }()); // 等待所有图片处理完成
              _context2.n = 1;
              return Promise.all(uploadPromises);
            case 1:
              uploadResults = _context2.v;
              this.getChangeImgaes(uploadResults);
              // 隐藏加载状态
              this.fullscreenLoading = false;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('图片处理失败:', _t2);
              this.fullscreenLoading = false;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleExternalImages(_x) {
        return _handleExternalImages.apply(this, arguments);
      }
      return handleExternalImages;
    }(),
    // 获取上传替换过后的图片地址
    getChangeImgaes: function getChangeImgaes(uploadResults) {
      // 创建图片映射对象
      var imgMap = {};
      // 构建图片映射
      uploadResults.forEach(function (result) {
        if (result.newUrl && result.newUrl !== result.oldUrl) {
          imgMap[result.oldUrl] = result.newUrl;
        }
      });

      // 更新封面图
      if (this.formValidate.image && imgMap[this.formValidate.image]) {
        this.formValidate.image = imgMap[this.formValidate.image];
      }

      // 更新轮播图
      if (this.formValidate.sliderImages && Array.isArray(this.formValidate.sliderImages)) {
        this.formValidate.sliderImages = this.formValidate.sliderImages.map(function (img) {
          return imgMap[img] || img;
        });
      }

      // 更新规格值图片
      if (this.formValidate.specType && this.formValidate.attrValueList) {
        this.formValidate.attrValueList.forEach(function (item) {
          if (item.image && imgMap[item.image]) {
            item.image = imgMap[item.image];
          }
        });
      }
    },
    // 下载图片并上传到服务器
    getImgData: function () {
      var _getImgData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(imgUrl) {
        var img, imgLoaded, canvas, ctx, blob, formData, data, res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              // 创建一个临时的img元素来加载图片
              img = new Image();
              img.crossOrigin = 'anonymous'; // 允许跨域

              // 使用Promise包装图片加载
              imgLoaded = new Promise(function (resolve, reject) {
                img.onload = function () {
                  return resolve(img);
                };
                img.onerror = function () {
                  return reject(new Error("\u56FE\u7247\u52A0\u8F7D\u5931\u8D25: ".concat(imgUrl)));
                };
                img.src = imgUrl;
              }); // 等待图片加载完成
              _context3.n = 1;
              return imgLoaded;
            case 1:
              // 创建canvas来获取图片数据
              canvas = document.createElement('canvas');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);

              // 将canvas转换为Blob
              _context3.n = 2;
              return new Promise(function (resolve) {
                canvas.toBlob(resolve, 'image/png');
              });
            case 2:
              blob = _context3.v;
              // 创建FormData对象
              formData = new FormData();
              formData.append('multipart', blob, 'image.png');
              data = {
                model: 'product',
                pid: 0
              }; // 调用上传接口
              _context3.n = 3;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 3:
              res = _context3.v;
              return _context3.a(2, res.url || imgUrl);
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('获取图片数据失败:', _t3);
              return _context3.a(2, imgUrl);
          }
        }, _callee3, null, [[0, 4]]);
      }));
      function getImgData(_x3) {
        return _getImgData.apply(this, arguments);
      }
      return getImgData;
    }(),
    // 获取选择的时间段
    getTimeCheckGroup: function getTimeCheckGroup() {
      this.timeCheckGroup = [];
      this.timeCheckGroup = this.formValidate.timeSlotAutomatic.filter(function (item) {
        return item.isCheck === 1;
      }).map(function (item) {
        return item.timeSlot;
      });
      this.timeCheckAll = this.timeCheckGroup.length === this.formValidate.timeSlotAutomatic.length;
    },
    // 编辑获取预约商品详情数据
    getReservationInfo: function getReservationInfo(info) {
      //时间段赋值
      if (info.supplementReservation.timeSlotStartEndTime) this.formValidate.temporaryData.reservationTime = info.supplementReservation.timeSlotStartEndTime.split(',');
      //预约商品时段划分类型：1-自动，2-自定义 , 编辑中赋值设置的时间段
      var timeSlotLists = info.timeSlotList.map(function (item) {
        return item.timeSlot;
      });
      if (info.supplementReservation.timeSlotClassifyType === 1) {
        this.formValidate.timeSlotAutomatic = info.timeSlotList;
        this.isCustomize = false;
        this.timeCheckGroup = timeSlotLists;
      } else {
        this.isCustomize = true;
        var formattedTimes = timeSlotLists.map(function (time) {
          return time.split('-');
        });
        this.formValidate.temporaryData.customizeTimeClone = formattedTimes;
        // this.customizeTimeData = timeSlotLists;
      }
      this.getChecked();
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (!tit && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (!tit && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (!tit && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (!tit && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    // 移动关键代码，包含轮播图、规格
    handleDragEnter: function handleDragEnter(e, item, index) {
      if (!this.isDisabled) {
        var _newItems;
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = [];
        newItems = _toConsumableArray(this.formValidate.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        (_newItems = newItems).splice.apply(_newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.formValidate.sliderImages = newItems;
      }
    }
  }
};